<div class="text-center text-light">
    <h1>Usuario aleatorio</h1>
    <p>Presiona para obtener datos aleatorios.</p>
    <button class="btn btn-primary" (click)="newRandomUser()">Nuevo Usuario</button>
</div>

<div class="text-light py-5" *ngFor="let user of randomUser.results">
    <div class="text-center">
        <img class="img-thumbnail" [src]="user.picture.large" alt="">
        <h3 class="mt-4">{{ user.name.first}} {{ user.name.last }}</h3>
    </div>
    <table  class="table table-dark table-striped">
        <thead>
          <tr>
            <th scope="col">Dato</th>
            <th scope="col">Información</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Género</th>
            <td>{{ user.gender }}</td>
          </tr>
          <tr>
            <th scope="row">Edad</th>
            <td>{{ user.dob.age }}</td>
          </tr>
          <tr>
            <th scope="row">Nacimiento</th>
            <td>{{ user.dob.date | date }}</td>
          </tr>
          <tr>
            <th scope="row">Email</th>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <th scope="row">Celular</th>
            <td>{{ user.cell }}</td>
          </tr>
          <tr>
            <th scope="row">Teléfono</th>
            <td>{{ user.phone }}</td>
          </tr>
          <tr>
            <th scope="row">Dirección</th>
            <td>{{ user.location.street.name }} #{{ user.location.street.number }}</td>
          </tr>
          <tr>
            <th scope="row">Ciudad</th>
            <td>{{ user.location.city }}</td>
          </tr>
          <tr>
            <th scope="row">Estado</th>
            <td>{{ user.location.state }}</td>
          </tr>
          <tr>
            <th scope="row">País</th>
            <td>{{ user.location.country }}</td>
          </tr>
          <tr>
            <th scope="row">Nacionalidad</th>
            <td>{{ user.nat }}</td>
          </tr>
          <tr>
            <th scope="row">Usuario</th>
            <td>{{ user.login.username }}</td>
          </tr>
          <tr>
            <th scope="row">Contraseña</th>
            <td>{{ user.login.password }}</td>
          </tr>
        </tbody>
    </table>
</div>